import { render, staticRenderFns } from "./ChooseLaser.vue?vue&type=template&id=5115f786&"
import script from "./ChooseLaser.vue?vue&type=script&lang=js&"
export * from "./ChooseLaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports